import React, {createContext, useEffect, useState} from "react";

export const dataContext = createContext();

const isLocal = window.location.href.indexOf("localhost") > 0;
let url = "/data_export.php";
if (isLocal) url = "https://fnxstudio.ru/data_export.php";

export const  ContextProvider = ({ children }) => {

const [data, setData] = useState({});
const [error, setError] = useState(null);
const [loading, setLoading] = useState(true);
const [isModal, setModal] = useState(false);

useEffect(() => {

setLoading(true);
fetch(url, {})
    .then(res => res.json())
    .then(data => {
        setData(data);
        setLoading(false);
    })
    .catch(err => {
    setError(err);
    setLoading(false);
    });
},[]);



const value = {

    isLocal, isModal, setModal,
   data, setData,
   error, setError,
   loading, setLoading

};

    return (
        <dataContext.Provider value={value}>{children}</dataContext.Provider>
    );

}